import { useEffect, useState } from "react";

import { Table } from "@smart/itops-sb-design-system-dom";
import { useLoadCompletedSubmissions } from "@smart/manage-gql-client-dom";

import { Empty } from "./empty";
import { useFilterSync } from "../filter-sync-context";
import {
  extendSubmissions,
  useCompletedSubmissionsColumns,
  useSubmissionsWithMatter,
  useSupplementalMatterTypes,
} from "../hooks";

export const CompletedSubmissions = () => {
  const [tableKey, setTableKey] = useState(0);
  const filterSync = useFilterSync();
  const { columns, select, sort, onRowClick, timeFilter, setTimeFilter } =
    useCompletedSubmissionsColumns();
  const { loading, result, refetching, refetch } = useLoadCompletedSubmissions(
    timeFilter,
    { reloadOnVisible: true, pollInterval: 180000 },
  );
  const { submissionsWithMatter: completedSubmissions } =
    useSubmissionsWithMatter({
      submissions: result,
      loading,
    });
  const supplementalMatterTypes =
    useSupplementalMatterTypes(completedSubmissions);

  useEffect(() => {
    if (timeFilter) refetch();
  }, [timeFilter]);

  useEffect(() => {
    if (filterSync?.tabKey !== "completed-forms") return;

    setTimeFilter(filterSync.period, filterSync.range);
    setTableKey(filterSync.nonce);
  }, [filterSync, setTimeFilter]);

  return (
    <Table
      key={`intake-completed-submissions-${tableKey}`}
      id="intake-completed-submissions"
      data={extendSubmissions(completedSubmissions, supplementalMatterTypes)}
      columns={columns}
      updating={loading || refetching}
      loadingRows={loading ? 3 : undefined}
      getRowId={(row) => row.uri}
      select={select}
      sort={sort}
      globalFilter={undefined}
      empty={<Empty message="No completed forms found" />}
      onRowClick={onRowClick}
      enableColumnFilters
      className="rounded-b-none"
      fixedHeadings
    />
  );
};
